import $ from 'jquery';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {ENDERECO_API} from '../../config/constant';

// ── Helpers ────────────────────────────────────────────────────────────────────────────────
const CONTROLLER = `${ENDERECO_API}src/api/controller/dashboardv2_controller.class.php`;

const _creds = () => {
  const storage = JSON.parse(base64_decode(sessionStorage.getItem('ddesp')));
  return {emp: storage[0], uid: storage[3], tipoUser: storage[7], token: storage[14]};
};

const _dd = (emp, uid, dataPost) =>
  base64_encode(
    [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))].join(',')
  );

const _decode = (data) => {
  if (data == null) return null;
  if (typeof data === 'object') return data;
  let raw = String(data).trim();
  if ((raw.startsWith('"') && raw.endsWith('"')) || (raw.startsWith("'") && raw.endsWith("'"))) {
    try { raw = JSON.parse(raw); } catch { raw = raw.slice(1, -1); }
  }
  try { return JSON.parse(base64_decode(raw)); } catch { /* */ }
  try { return JSON.parse(raw); } catch { /* */ }
  return raw;
};

// ── API pública ────────────────────────────────────────────────────────────────────────────────
//Nao repetir esta lógica em outros arquivos, pois perdemos tratamento por requisição
const RestDashV2Post = (config) => {
  const Arr_    = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const {dataPost = []} = Arr_;

  return new Promise((resolve, reject) => {
    try {
      const {emp, uid, tipoUser, token} = _creds();
      const dp = [...dataPost, tipoUser];

      $.ajax({
        url:      encodeURI(CONTROLLER),
        type:     'POST',
        dataType: 'text',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer ' + token,
        },
        data: {
          ll: base64_encode(caminho),
          dd: _dd(emp, uid, dp),
        },
        success: (data) => resolve([200, _decode(data)]),
        error:   (xhr)  => reject([xhr?.status || 400, {message: 'Dados não localizados', status: xhr?.status}]),
      });
    } catch (err) {
      reject([500, {message: 'Server Error'}]);
    }
  });
};

const RestDashV2Get = (config) => {
  const caminho = config.dest.trim();
  const dataPost = config.dataPost || [];

  return new Promise((resolve, reject) => {
    try {
      const {emp, uid, token} = _creds();

      $.ajax({
        url:      encodeURI(CONTROLLER),
        type:     'GET',
        dataType: 'text',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        data: {
          ll: base64_encode(caminho),
          dd: _dd(emp, uid, dataPost),
        },
        success: (data) => resolve([200, _decode(data)]),
        error:   (xhr)  => reject([xhr?.status || 400, {message: 'Dados não localizados', status: xhr?.status}]),
      });
    } catch (err) {
      reject([500, {message: 'Server Error'}]);
    }
  });
};

export {RestDashV2Post, RestDashV2Get};
